import { format } from 'date-fns';
import stringToDate from './string-to-date';

export default (dateString: string): string => {
  const parsedDate: Date = stringToDate(dateString);

  return format(parsedDate, 'dd.MM.yy HH:mm');
};
